// extracted by mini-css-extract-plugin
export default {"container-section":"Home_container-section__FZmRH"};